import AppBar from "@material-ui/core/AppBar";
import {
  createTheme,
  makeStyles,
  MuiThemeProvider
} from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import footerPanelStyle from "assets/jss/style-component/components/footerPanelStyle.js";
import { Spinner } from "components";
import { MoreIcon } from "icons";
import PropTypes from "prop-types";
import React from "react";

const useFooterStyles = makeStyles(footerPanelStyle);

const theme = createTheme({
  overrides: {
    MuiToolbar: {
      root: {
        color: "#3c4858",
        minHeight: "40px !important"
      },
      regular: {
        minHeight: "40px !important"
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: "1.2rem"
      }
    },
    MuiButtonBase: {
      root: {
        margin: "4px",
        padding: "4px !important"
      }
    }
  }
});

export default function FooterTab(props) {
  const classesFooter = useFooterStyles();
  const { children, loading } = props;

  return (
    <AppBar
      position="absolute"
      color="primary"
      className={classesFooter.appBar}
    >
      <MuiThemeProvider theme={theme}>
        <Toolbar>
          <MoreIcon />
          <Spinner size={25} loading={loading} />
          {!loading && children}
          <div className={classesFooter.grow} />

          <MoreIcon />

        </Toolbar>
      </MuiThemeProvider>
    </AppBar>
  );
}
FooterTab.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  handleNotificar: PropTypes.func
};
